import React, { useState, useRef } from 'react';

import * as general from '@/components/general/FormPages.styled';

import { InputField, Button, BlurBox, Layout } from '@/components/general';
import { FormBox, ButtonBox } from './Content.styled';

export const Content = () => {
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(true);

  const formRef = useRef(null);

  const checkIfInputsAreNotEmpty = () => {
    let values: string[] = [];
    if (formRef?.current) {
      const childs = formRef.current.childNodes;
      childs.forEach((child) => {
        const input = child.getElementsByTagName('input')[0];
        if (input) {
          if (input.required) {
            values = [...values, input.value];
          }
        }
      });
    }
    if (values.some((val) => val === '')) {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  return (
    <Layout $flexGrow>
      <BlurBox $maxHeightNone>
        <general.Title>Sign in to CodePlatform</general.Title>
        <general.UnderTitle>Enter your details below</general.UnderTitle>
        <FormBox id="sign-in" ref={formRef} onChange={checkIfInputsAreNotEmpty}>
          <InputField
            required
            placeholder="Enter your Email adress"
            type="email"
            name="email"
            labelToShow
          >
            Email Address
          </InputField>
          <InputField
            required
            placeholder="Password"
            labelToShow
            name="password"
            type="password"
          >
            Enter your password
          </InputField>
          <ButtonBox>
            <Button type="submit" disabled={buttonDisabled}>
              Sign in
            </Button>
          </ButtonBox>
        </FormBox>
      </BlurBox>
    </Layout>
  );
};
